(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "lodash"], factory);
	else if(typeof exports === 'object')
		exports["SpotifyViewerWidget"] = factory(require("react"), require("lodash"));
	else
		root["SpotifyViewerWidget"] = factory(root["React"], root["_"]);
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__751__, __WEBPACK_EXTERNAL_MODULE__6252__) => {
return 